import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import logoDeduca from "../../../../../../assets/img/logo-deduca.svg";
import logoGokursos from "../../../../../../assets/img/logo-gokursos.svg";
import iconDeduca from "../../../../../../assets/img/logo-deduca-icon.svg";
import iconGokursos from "../../../../../../assets/img/logo-gokursos-icon.svg";

import { IntegrationDeduca } from "./deduca-integration";
import { getConnectionCredentials } from "../../../../../services/manager-settings.service";
import { changeStatusIntegration, getIntegrations } from "../../../../../services/manager/admin/settings.service";

export const Integrations = (): JSX.Element => {

  const [haveDeducaConfig, setHaveDeducaConfig] = useState(false)
  const [haveGokursosConfig] = useState(false)
  const [showFormIntegration, setShowFormIntegration] = useState(false)
  const [enableDeducaIntegration, setEnableDeducaIntegration] = useState(false)
  const [enableGokursosIntegration, setEnableGokursosIntegration] = useState(false)

  const handleActiveIntegration = (integration_name: string) => {
    if (integration_name === 'deduca') {
      setEnableDeducaIntegration(!enableDeducaIntegration)
      changeStatusIntegration(integration_name, !enableDeducaIntegration).then(() => {
        toast.success(`Integração ${!enableDeducaIntegration === true ? "ativada" : "inativada"} com sucesso!`)
      }).catch(() => {
        toast.error(`Ocorreu um erro ao ${!enableDeducaIntegration === true ? "ativar" : "inativar"} a integração. Tente novamente.`)
      })
    } else if (integration_name === 'gokursos') {
      console.log('gokursos')
    }
  }

  useEffect(() => {
    getConnectionCredentials().then((res) => {
      if (res.id) {
        setHaveDeducaConfig(true)
      } else {
        setHaveDeducaConfig(false)
      }
    })

    getIntegrations().then((integrations) => {
      integrations.map((integration: any) => {
        if (integration.name === "Deduca") {
          setEnableDeducaIntegration(integration.is_active)
        }
      })
    })
  }, [])

  if (showFormIntegration) {
    return (
      <IntegrationDeduca setShowFormIntegration={setShowFormIntegration}/>
    )
  }

  return (
    <Row className="ml-2 mr-1">
      <OverlayTrigger
        placement={'top'}
        overlay={<Tooltip>Configurar</Tooltip>}
      >
        <Col md={6} lg={6} xxl={3} className="mt-3">
          <Card className="bg-card-integration">
            <span onClick={() => setShowFormIntegration(true)}>
              <div className="text-end mr-4 py-5">
                <img src={logoDeduca} height={45} alt="" />
              </div>
              <div className="icon-integration">
                <img src={iconDeduca} height={30} alt="" />
              </div>
            </span>
            <Card.Body className="bg-body-card-integration d-flex" style={{ flexDirection: 'column' }}>
              <Col xs={12} className="mt-4" onClick={() => setShowFormIntegration(true)}>
                <h6 className="text-black mb-1"><b>Deduca</b></h6>
                <p className="font-12 font-light text-dark-grey">por Delinea Edtech</p>
                <p className="font-14 text-darker-grey">
                  Permite a importação de materiais da plataforma deduca.
                </p>
              </Col>
              <div style={{ height: '100%', display: 'flex' }}>
                <Col xs={12} className="d-flex align-items-end mt-4">
                  {
                    haveDeducaConfig ? (
                      <>
                        <p className="mb-0 mr-2">{enableDeducaIntegration ? "ON" : "OFF"}</p>
                        <Form.Check
                          type="switch"
                          checked={enableDeducaIntegration}
                          onChange={(e: any) => handleActiveIntegration("deduca")}
                        />
                      </>
                    ) : (
                      <div className="bg-light">
                        <span className="ml-1 mr-1">OFF</span>
                      </div>
                    )
                  }
                </Col>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </OverlayTrigger>

      <OverlayTrigger
        placement={'top'}
        overlay={<Tooltip>Configurar</Tooltip>}
      >
        <Col md={6} lg={6} xxl={3} className="mt-3">
          <Card className="bg-card-integration bg-gokursos">
            <div className="text-end mr-4 py-5">
              <img src={logoGokursos} height={45} alt="" />
            </div>
            <div className="icon-integration">
              <img src={iconGokursos} height={30} alt="" />
            </div>
            <Card.Body className="bg-body-card-integration d-flex" style={{ flexDirection: 'column' }}>
              <Col xs={12} className="mt-4">
                <h6 className="text-black mb-1"><b>Gokursos</b></h6>
                <p className="font-12 font-light text-dark-grey">por GodigitalEdu</p>
                <p className="font-14 text-darker-grey">
                  Permite a troca de informações a respeito dos planos cadastrados na gokursos com os cadastrados na dstore.
                </p>
              </Col>

              <div style={{ height: '100%', display: 'flex' }}>
                <Col xs={12} className="d-flex align-items-end mt-3">
                  {
                    haveGokursosConfig ? (
                      <>
                        <p className="mb-0 mr-2">{enableGokursosIntegration ? "ON" : "OFF"}</p>
                        <Form.Check
                          type="switch"
                          checked={enableGokursosIntegration}
                          onChange={() => setEnableGokursosIntegration(!enableGokursosIntegration)}
                        />
                      </>
                    ) : (
                      <div className="bg-light">
                        <span className="ml-1 mr-1">OFF</span>
                      </div>
                    )
                  }
                </Col>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </OverlayTrigger>
    </Row>
  )
}